//libs
import React, { memo } from 'react';

//styles
import { Image, Title, Subtitle, Pricing } from './styles';

interface ProductPlaceHolderProps {
  className?: string;
}
const Placeholder = ({ className = '' }: ProductPlaceHolderProps) => {
  return (
    <div className={className}>
      <Image />
      <Title />
      <Subtitle />
      <Pricing />
    </div>
  );
};

export default memo(Placeholder);
